// Do not edit! This file is maintained automatically,
// please use 'npm run index' instead
import './dialog-message';
import './fixed';
import './mini-message';
import './ng-enter';
import './on-click-select';
import './print-element';
import './set-focus';
import './show-class';
import './sw-check-version';
